export default {
  addMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points',
    method: 'post',
  },
  getMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}',
    method: 'get',
  },
  getMeasuringPoints: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points',
    method: 'get',
  },
  getCommands: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/commands',
    method: 'get',
  },

  sendCommand: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/send-command',
    method: 'post',
  },

  // 获取项目下特定监测类型测点 measurement
  getProjectMeasuringPoints: {
    server: '/projects/{projectId}/measuring-points',
    method: 'get',
  },
  getProjectMeasuringPointsThroughCategory: {
    server: '/projects/{projectId}/measuring-points/through-category',
    method: 'get',
  },

  putMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}',
    method: 'put',
  },
  deleteMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}',
    method: 'delete',
  },
  statMeasuringPoint: {
    server: '/projects/{projectId}/measuring-points/stat',
    method: 'get',
  },
  getDeviceGroup: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/device-group',
    method: 'get',
  },
  patchMeasuringPointsComputedField: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/computed-field',
    method: 'patch',
  },
  patchMeasuringPointsHealthThreshold: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/health-threshold',
    method: 'patch',
  },
  patchMeasuringPointCollectConfig: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/collect-config',
    method: 'patch',
  },
  postMeasuringPointsFieldThreshold: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/field-threshold',
    method: 'post',
  },
  putMeasuringPointsFieldThreshold: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/thresholds/{thresholdId}',
    method: 'put',
  },
  getMeasuringPointThresholds: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/thresholds',
    method: 'get',
  },
  getMeasuringPointRoute: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/route',
    method: 'get',
  },
  deleteMeasuringPointThreshold: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/thresholds/{thresholdId}',
    method: 'delete',
  },
  // 提交测点的lacation和关联的测点
  putPointsLocation: {
    server: '/projects/{projectId}/structures/{structureId}/points-location',
    method: 'put',
  },
  // 开启或关闭保持下发命令任务，用于设备测试
  keepSendingCommand: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/keep-sending-command',
    method: 'post',
  },
  // 获取挂起命令
  getHangCommandJobs: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/hang-command-jobs',
    method: 'get',
  },
  // 取消挂起的命令任务
  cancelHangCommandJob: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/cancel-hang-command-job',
    method: 'post',
  },

  addMasterMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/master-points',
    method: 'post',
  },
  putMasterMeasuringPoint: {
    server: '/projects/{projectId}/structures/{structureId}/master-points/{measuringPointId}',
    method: 'put',
  },
  setMasterPointInit: {
    server: '/projects/{projectId}/structures/{structureId}/master-points/{measuringPointId}/init',
    method: 'post',
  },
  updateMonitorSwitch: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/monitor-switch',
    method: 'patch',
  },
  updateStructureMonitorSwitch: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/monitor-switch',
    method: 'patch',
  },
  deviceConnect: {
    server: '/projects/{projectId}/structures/{structureId}/measuring-points/{measuringPointId}/device-connect',
    method: 'get',
  },
};
